export const mock = {
  displayName: 'Test Name',
  email: 'Test Email',
  atlassianAccountId: '1234',
  product: 'PPC',
};
